<template>
  <div class="p-3 card">
    <label class="titlePage">Configuração Definida para Publicação</label>
    <fccTable striped hover responsive :fields="fields" :items="items"> </fccTable>

    <div class="text-right mb-3">
      <fccButton @click="abrirModalEditarConfiguracao" class="mr-2" :disabled="disabled">{{
        labelsSystem.editar
      }}</fccButton>
      <fccButton @click="excluirConfiguracao" :disabled="disabled">{{
        labelsSystem.excluir
      }}</fccButton>
    </div>
    <fccModal
      :idModal="'modal-edit' + _uid"
      :titleModal="titleModalEdit"
      size="lg"
      centered
      escondeFooter
      travaEsc
      travaBack
    >
      <b-form @submit.prevent="editarConfiguracaoDaPublicacao" autocomplete="off">
        <div class="row">
          <div class="col-md-6">
            <fcc-select :value="spi" :clearable="false" disabled required>SPI</fcc-select>
          </div>

          <div class="col-md-6">
            <fcc-select
              label-field="solicitacao"
              value-field="solicitacao"
              v-model="idSolicitacao"
              :options="listaSolicitacoes"
              :clearable="false"
              :disabled="!spi"
              required
              >Solicitação</fcc-select
            >
          </div>
        </div>

        <div class="row innerPage">
          <div class="col-md-6">
            <fcc-select :value="idFase" :clearable="false" disabled>Fase</fcc-select>
          </div>

          <div class="col-md-6">
            <fcc-select :value="idAplic" :clearable="false" disabled>Aplicação</fcc-select>
          </div>
        </div>

        <div class="row mb-4 row innerPage">
          <div class="col-md-6">
            <fccDateInput type="datetime" v-model="dataInicioAcesso" required
              >Data inicial de acesso</fccDateInput
            >
          </div>
          <div class="col-md-6">
            <fccDateInput type="datetime" v-model="dataFimAcesso" required
              >Data final de acesso</fccDateInput
            >
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 text-right">
            <fccButton
              classeAdd="form-control"
              tipo="submit"
              :disabled="!todosCamposSelecionados"
              >{{ labelsSystem.salvar }}</fccButton
            >
          </div>
        </div>
      </b-form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../../../store'
import fccConfiguracaoPublicacaoMixin from './fccConfiguracaoPublicacaoMixin'
import { TP_ETAPA, TP_SITUACAO } from '../../constantes'

export default {
  mixins: [fccConfiguracaoPublicacaoMixin],
  data() {
    return {
      idLocalConfig: '',
      fields: [
        { key: 'idlocalconfig', label: 'ID', sortable: true },
        { key: 'spi', label: 'SPI', sortable: true },
        { key: 'idfase', label: 'Fase', sortable: true },
        { key: 'idaplic', label: 'Aplicação', sortable: true },
        { key: 'idsolicitacao', label: 'Solicitação', sortable: true },
        { key: 'datainicioacesso', label: 'Data Inicial de Acesso', sortable: true },
        { key: 'datafimacesso', label: 'Data Final de Acesso', sortable: true },
        { key: 'cdfuncionario', label: 'Técnico', sortable: true },
        { key: 'dataconfig', label: 'Data da Configuração', sortable: true }
      ],
      titleModalEdit: 'Editar Configuração'
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    items() {
      return new Array(this.configuracao)
    },
    status() {
      return store.state.localDeProva.listaStatus
    },
    disabled() {
      return (
        this.status?.find((item) => item.tpEtapa === TP_ETAPA.CONFIGURACAO)?.tpSituacao ===
        TP_SITUACAO.CANCELADO
      )
    }
  },
  methods: {
    excluirConfiguracao() {
      this.callConfirm(this.mensagemExcluir, '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              store.state.baseUrlLocalDeProva +
                `LocalExameConfig/Delete/${this.configuracao.idlocalconfig}/${this.dadosUserSession.usuCdFuncionario}`,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              store.commit('localDeProva/RESET_STORE')
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    },
    editarConfiguracaoDaPublicacao() {
      axios
        .put(
          store.state.baseUrlLocalDeProva + `LocalExameConfig/Update`,
          this.configuracaoDaPublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          store.dispatch(
            'localDeProva/fetchConfiguracao',
            this.configuracao.idlocalconfig,
            this.dadosLoginSession.fccTokenHeaders
          )
          this.$root.$emit('bv::hide::modal', 'modal-edit' + this._uid)
        })
        .catch(this.setErrorSystem)
    },
    abrirModalEditarConfiguracao() {
      this.idLocalConfig = this.configuracao?.idlocalconfig
      this.cdFuncionario = this.configuracao?.cdfuncionario
      this.spi = this.configuracao?.spi
      this.$nextTick().then(() => {
        this.idSolicitacao = this.configuracao?.idsolicitacao
        this.idFase = this.configuracao?.idfase
        this.idAplic = this.configuracao?.idaplic
        this.dataInicioAcesso = this.configuracao?.datainicioacesso
        this.dataFimAcesso = this.configuracao?.datafimacesso
        this.dataConfig = this.configuracao?.dataconfig
      })

      this.$root.$emit('bv::show::modal', 'modal-edit' + this._uid)
    }
  }
}
</script>